import type { ReactNode } from "react";

interface StepLayoutProps {
	header: ReactNode;
	content: ReactNode;
	footer?: ReactNode;
}

export default function StepLayout({ header, content, footer }: StepLayoutProps) {
	return (
		<div className="flex flex-col gap-8 h-full p-8 bg-white border border-gray-200 rounded-lg">
			<div className="shrink-0">{header}</div>
			<div className="grow">{content}</div>
			{footer && <div className="shrink-0 mt-auto">{footer}</div>}
		</div>
	);
}
